module.exports = __webpack_public_path__ + "img/refe.404fe2b5.png";